/**
 * ===========================
 * MAIN
 * ===========================
 */

import { createNewLaunchSectionData } from '@apps/components/CarLaunch/CarLaunchMonthSectionContent/helper';
import { CarLaunchMonthSectionType } from '@apps/components/CarLaunch/CarLaunchMonthSectionContent/props';
import { BASE_URL } from '@apps/config';
import {
  getAllBrandsInitial,
  getCarNewLaunch,
  getNewCarByFilter,
} from '@apps/config/API/new-car.config';
import NewLaunchScreen from '@apps/screens/NewLaunch';
import _ from 'lodash';
import { NextPage, NextPageContext } from 'next';
import { useRouter } from 'next/router';
import { NextSeo, NextSeoProps } from 'next-seo';

const Page: NextPage = (props) => {
  const { sectionsData, miscellaneousData, settings, filterList, webView } =
    props;
  // ======================= HOOKS
  const router = useRouter();
  // const { t } = useTranslation('common');

  // ======================= STATE

  // ======================= VARIABLES
  const newCarLaunch = sectionsData;
  const popularBrand = settings.car_brand_featured;
  const yearMonthObject = miscellaneousData?.year_month_list;

  const settingsList = {
    budget: miscellaneousData.budget_list,
    monthly_payment: miscellaneousData.monthly_payment_list,
    segment: miscellaneousData.car_segment_type_list,
    capacity: miscellaneousData.capacity_list,
    fuel_type: miscellaneousData.fuel_type_list,
    transmission: miscellaneousData.car_variant_transmission_list,
    seat: miscellaneousData.car_seat,
    body_type: settings?.car_body,
  };
  const currentUrl = `${BASE_URL}${router?.asPath}`;
  const canonicalPath = currentUrl.split('?')[0].toLowerCase();
  const nextSeoProps: NextSeoProps = {
    defaultTitle:
      'Latest Car Launches in Malaysia: New Models, Prices & Details | Carz Automedia Malaysia',
    description:
      'Stay updated with the latest car launches in Malaysia. Explore new models, features, pricing, and specifications for petrol, hybrid, and EV cars on Carz Automedia Malaysia',
    canonical: canonicalPath,
  };

  // ======================= VIEWS
  return (
    <>
      {!webView && <NextSeo {...nextSeoProps} />}
      <NewLaunchScreen
        carNewLaunch={newCarLaunch}
        yearMonthObject={yearMonthObject}
        popularBrand={popularBrand}
        settings={settingsList}
        filterList={filterList}
        webView={webView}
      />
    </>
  );
};

/**
 * ===========================
 * SERVER SIDE RENDERING
 * ===========================
 */
export async function getServerSideProps(ctx: NextPageContext) {
  const { data: newLaunchCars } = await getCarNewLaunch();
  const miscellaneousData = await getAllBrandsInitial();
  const sectionsData = createNewLaunchSectionData({
    yearMonthObject: miscellaneousData?.year_month_list,
    newLaunchCars,
  });
  const query = ctx?.query;
  let filterList: CarLaunchMonthSectionType[] = [];
  if (!_.isEmpty(query)) {
    const { data: filteredNewLaunchCars } = await getNewCarByFilter({
      query,
      path: `car_info/new_launch`,
    });
    filterList = createNewLaunchSectionData({
      yearMonthObject: miscellaneousData?.year_month_list,
      newLaunchCars: filteredNewLaunchCars,
    });
  }
  return {
    props: {
      sectionsData,
      miscellaneousData,
      filterList,
    },
  };
}

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default Page;
